import React from "react";
import { Link } from "react-router-dom";

// Local Libraries
import phrasebookLoad from "../../../i18n";
import { gisRoutes } from "../../../routes/routes";
import { connect } from "react-redux";
import { userStorage } from "../../../helpers/user-storage";

import * as token from "../../../helpers/token";
import {
  accountTypesConstants,
  portalFunctionalityConstants,
  permissionTypeConst,
} from "../../../constants";
import { capitalizeFirstLetter, permissionFinder } from "../../../helpers/util";

//Redux
import {
  georesourceActions,
  customerActions,
  orderActions,
  serviceNumberTypeActions,
} from "actions";

//componenets
import { Table } from "../../../components/SkyFramework/Tables/Table.jsx";
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SearchBox } from "../../../components/SkyFramework/Search";
import { PaginationBar } from "../../../components/SkyFramework/Pagination/PaginationBar.jsx";

// Constants
const phrasebook = phrasebookLoad();

class Ordering extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      service_types: [
        { value: "ITFS", label: "ITFS" },
        { value: "UIFN", label: "UIFN" },
        { value: "DID", label: "DID" },
        { value: "SIP Trunking", label: "SIP Trunking" },
      ],
      status_types: [
        { value: "requested", label: "Requested" },
        { value: "processed", label: "Processed" },
        { value: "confirmed", label: "Confirmed" },
        { value: "accepted", label: "Accepted" },
        { value: "assigned", label: "Assigned" },
        { value: "testing", label: "Testing" },
        { value: "completed", label: "Completed" },
        { value: "cancellation", label: "Cancellation" },
        { value: "cancelled", label: "Cancelled" },
      ],
      jurisdiction_coverage: undefined,
      cities: [],
      country_code: undefined,
      numbers: undefined,
      pricing: undefined,
      orders: undefined,
      customers: undefined,

      number_id: undefined,
      customer_id: userStorage.getUser().customer_id
        ? userStorage.getUser().customer_id
        : undefined,
      service_type: undefined,
      jurisdiction: undefined,
      status: undefined,
      order_id: undefined,
      reference: undefined,
      user_id: userStorage.getUser().id,
      pricing_id: undefined,

      limit: 10,
      page: 1,
      filters: { orderby: 'updatedAt', asc: true },
      submitted: false,
    };
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (token.loggedAccountType() < 200) {
      this.props.dispatch(customerActions.getAll(0, this.state.page));
    }
    this.props.dispatch(serviceNumberTypeActions.getAllCoverage(undefined));

    this.props.dispatch(georesourceActions.getCountries(null, 1000));
    this.props.dispatch(georesourceActions.getCountryCodes(null, 1000));
    this.props.dispatch(georesourceActions.getCities(null, "", 1000));
    // this.props.dispatch(numberActions.getAll(undefined, 0, 0));
    this.props.dispatch(orderActions.getAll(this.state.limit, 0, this.state.filters));
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.jurisdictions &&
      prevProps &&
      prevProps.jurisdictions !== this.props.jurisdictions
    )
      this.setState({
        jurisdiction_coverage: this.props.jurisdictions,
      });
    if (
      this.props.orders &&
      prevProps &&
      prevProps.orders !== this.props.orders
    )
      this.setState({ orders: this.props.orders });

    if (
      this.props.customers &&
      prevProps &&
      prevProps.customers !== this.props.customers
    ) {
      this.setState({ customers: this.props.customers.data });
    }
  }

  onPageChanged = (currentPage) => {
    this.setState({ page: currentPage });
    this.props.dispatch(
      orderActions.getAll(this.state.limit, currentPage - 1, this.state.filters)
    );
  };

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();

    var filters = {
      service_type: this.state.service_type,
      jurisdiction: this.state.jurisdiction,
      status: this.state.status,
      order_id: this.state.order_id,
      reference: this.state.reference,
      orderby: 'updatedAt', asc: true
    };
    if (token.loggedAccountType() < 200) {
      filters.customer_id = this.state.customer_id;
    }

    this.setState({ filters: filters });
    this.props.dispatch(orderActions.getAll(this.state.limit, 0, filters));
  };

  // handleDeleteSubmit = (event) => {
  //   const { id } = event.target;
  //   this.props.dispatch(accountActions.deleteAccount(id));
  // }

  SearchBox() {
    var filters = [[]];
    if (this.state.jurisdiction_coverage) {
      if (token.loggedAccountType() < 200 && this.state.customers) {
        const customerOptions = this.state.customers.map(function (customer) {
          return {
            value: customer["id"],
            label: capitalizeFirstLetter(customer["name"]),
          };
        });
        filters[0].push({
          label: phrasebook.common.customer,
          type: "select",
          id: "customer_id",
          tooltip: "Customer orders",
          name: "customer_id",
          options: customerOptions,
          empty_option: true,
        });
      }
      const jurisdictionOptions = this.state.jurisdiction_coverage.data.map(
        function (jurisdiction) {
          return { value: jurisdiction, label: jurisdiction };
        }
      );
      filters[0].push({
        label: phrasebook.numbers.service_type,
        type: "select",
        id: "service_type",
        name: "service_type",
        options: this.state.service_types,
        empty_option: true,
      });

      filters.push(
        [{
          label: phrasebook.common.status,
          type: "select",
          id: "status",
          name: "status",
          options: this.state.status_types,
          empty_option: true,
        },
        {
          label: `${phrasebook.headerlinks.order} ID`,
          type: "text",
          id: "order_id",
          name: "order_id",
        },
        {
          label: `${phrasebook.common.customer} ${phrasebook.references.reference}`,
          type: "text",
          id: "reference",
          name: "reference",
        },
        // { label: phrasebook.common.id, type: "text", id: "order_id", name: "order_id" },
        {
          label: phrasebook.profile.jurisdiction,
          type: "select",
          id: "jurisdiction",
          tooltip: "jurisdiction",
          name: "jurisdiction",
          options: jurisdictionOptions,
          empty_option: true,
        }]
      );
      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />
      );
    } else return null;
  }

  canAdd() {
    if (
      permissionFinder(
        this.props.loggedpermissions.loggedPermissions,
        token.loggedAccountType(),
        portalFunctionalityConstants.management.order,
        permissionTypeConst.ADD,
        token.loggedToken()
      )
    )
      return (
        <div class="ml-sm-auto mt-1 mt-sm-0">
          <Link to={gisRoutes.management.order.add}>
            <button type="button" class="btn btn-main">
              {phrasebook.orders.make_order}
            </button>
          </Link>
        </div>
      );
  }

  OrderList() {
    if (this.state.orders) {
      var labels = [
        `${phrasebook.headerlinks.order} ID`,
        phrasebook.services.service,
        phrasebook.profile.jurisdiction,
        `${phrasebook.common.customer} ${phrasebook.references.reference}`,
        phrasebook.common.status,
        phrasebook.common.quantity,
        phrasebook.orders.channel_quantity,
        phrasebook.references.currency,
        phrasebook.pricing.nrc,
        phrasebook.pricing.mrc,
        phrasebook.status.created,
      ];

      var fields = [
        "id",
        ["servicenumbertypeorderhistory", "service_type"],
        ["servicenumbertypeorderhistory", "jurisdiction"],
        "reference",
        "status",
        "number_quantity",
        "channel_quantity",
        ["servicenumbertypeorderhistory", "currency"],
        ["servicenumbertypeorderhistory", "nrc"],
        ["servicenumbertypeorderhistory", "mrc"],
        "date_purchase",
      ];

      if (token.loggedAccountType() < 200) {
        labels.unshift(phrasebook.common.customer);
        fields.unshift(["customer", "name"]);
      }
      var actions = [];
      if (
        permissionFinder(
          this.props.loggedpermissions.loggedPermissions,
          token.loggedAccountType(),
          portalFunctionalityConstants.management.order,
          permissionTypeConst.EDIT,
          token.loggedToken()
        )
      )
        actions.push({
          location: gisRoutes.management.order.edit,
          label: phrasebook.common.edit,
          type: "link",
        });
      // if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.account.account, permissionTypeConst.DELETE, token.loggedToken())) actions.push({
      //   location: gisRoutes.account.account.delete,
      //   label: phrasebook.common.delete,
      //   type: 'action',
      //   onClick: this.handleDeleteSubmit
      // })
      actions.push({
        location: gisRoutes.management.order.read,
        label: phrasebook.common.show,
        type: "link",
      });

      return (
        <>
          {this.canAdd()}
          <br></br>
          <Table
            values={this.state.orders.data}
            limit={this.state.limit}
            currentPage={this.state.page}
            pageNeighbours={this.state.pageNeighbours}
            onPageChanged={this}
            nofound={phrasebook.common.nodatafound}
            headers={labels}
            keys={fields}
            actions={actions}
            action_key={"id"}
          />
          <PaginationBar
            limit={this.state.limit}
            total={this.state.orders.count}
            currentPage={this.state.page}
            onPageChanged={this}
            pageNeighbours={this.state.pageNeighbours}
          />
        </>
      );
    } else return null;
  }

  render() {
    return (
      <>
        <NewBreadcrumbs
          crumbs={[
            {
              link: gisRoutes.dashboard[this.account_type_logged],
              label: phrasebook.common.home,
            },
          ]}
          current={phrasebook.headerlinks.orders}
        />

        <div className="box p-1 p-sm-2">
          <h2 className="box-title pb-1 mb-1">
            {phrasebook.headerlinks.orders}
          </h2>
          {this.SearchBox()}
        </div>
        <div className="box p-1 p-sm-2 my-md-1">
          <h3 className="box-title pb-1 mb-1">{phrasebook.headerlinks.orders}</h3>
          <div class="alert alert-warning"><p>*status requested = order created by the customer, status processed = order prepared by your account manager</p></div>
          {this.OrderList()}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const {
    loggedpermissions,
    georesource,
    authentication,
    order,
    customer,
    servicenumbertype,
  } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    dialcodes: georesource.dialcodes,
    jurisdictions: servicenumbertype.servicenumbertypecoverage,
    cities: georesource.cities,
    customers: customer.customers,
    orders: order.orders,
  };
}

const ordering = connect(mapStateToProps)(Ordering);
export default ordering;
